"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPageInfo = exports.convertCursor = exports.buildPage = void 0;
function buildPage(pageable, totalCount, contents) {
    const offset = pageable.page * pageable.pageSize;
    return {
        contents,
        totalCount,
        pageable,
        hasNext: offset + contents.length < totalCount,
        hasPrevious: pageable.page > 0,
    };
}
exports.buildPage = buildPage;
function isGlobalIdentity(item) {
    return item.toGlobalId !== undefined;
}
function convertCursor(item) {
    return Buffer.from(isGlobalIdentity(item) ? item.toGlobalId() : 'unsupported').toString('base64');
}
exports.convertCursor = convertCursor;
function buildPageInfo(data) {
    return {
        hasNextPage: data.hasNext,
        hasPreviousPage: data.hasPrevious,
        endCursor: data.contents.length > 0 ? convertCursor(data.contents[data.contents.length - 1]) : null,
    };
}
exports.buildPageInfo = buildPageInfo;
